import React, { useState, useEffect } from 'react';
import './App.css';
import Layout from './components/layout';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import LinkList from './components/link';
import Button from '@material-ui/core/Button';
import Dexie from 'dexie';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: '50px',
		[theme.breakpoints.down('sm')]: {
			marginTop: '20px',
		},
	},

	descriptionStyle: {
		display: 'none',
	},

	listStyle: {
		margin: '0 auto',
		maxWidth: '750px',
	},

	btnWrapperWraper: {
		marginTop: '20px',
		[theme.breakpoints.down('sm')]: {
			padding: '15px',
			marginTop: '0px',
		},
	},

	btnWrapper: {
		margin: '0 auto',
		padding: '15px',
		maxWidth: '690px',
		backgroundColor: 'white',
	},

	btnStyle: {
		marginBottom: '20px',
	},

	textFormStyle: {
		// background: '#dcd4d4',
		color: 'white',
		'& label.Mui-focused': {
			color: 'white',
		},
		'& .MuiOutlinedInput-input': {
			color: 'white',
		},
		'&::placeholder': {
			color: 'white !important',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: 'whitesmoke',
		},
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: 'whitesmoke',
			},
			'&:hover fieldset': {
				borderColor: 'white',
			},
			'&.Mui-focused fieldset': {
				borderColor: 'white',
			},
		},
	},

	inpuStyleTextColor: {
		color: 'white',
	},

	textFieldStyle: {
		background: 'white',

		color: 'white',
		'& label.Mui-focused': {
			color: '#999',
		},
		'& .MuiOutlinedInput-input': {
			color: '#999',
		},
		'&::placeholder': {
			color: 'white !important',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: 'whitesmoke',
		},
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: 'whitesmoke',
			},
			'&:hover fieldset': {
				borderColor: 'white',
			},
			'&.Mui-focused fieldset': {
				borderColor: 'white',
			},
		},
	},
}));

function App() {
	//set the database
	const db = new Dexie('LinkSaver');
	//create the database store
	db.version(1).stores({
		links: '++id, link',
	});
	db.open().catch((err) => {
		console.log(err.stack || err);
	});

	const classes = useStyles();
	const [linkObj, setLinkObj] = useState({
		title: '',
		subTitle: '',
		url: '',
	});
	const [links, setLinks] = useState([]);
	const [editState, setEditState] = useState(false);
	const [editId, setEditId] = useState(null);

	useEffect(() => {
		getLinks();
	}, [links]);

	const getLinks = async () => {
		let links = await db.links?.reverse().toArray();
		setLinks(links);
	};
	const handleChangeInput = (event) => {
		let value = event.target.value;

		setLinkObj({
			...linkObj,
			[event.target.name]: value,
		});
	};

	const saveLink = () => {
		const newLink = {
			title: linkObj.title,
			subTitle: linkObj.subTitle,
			url: linkObj.url,
		};

		db.links.add(newLink).then(async () => {
			//retrieve all posts inside the database
			let allLinks = await db.links?.reverse().toArray();
			//set the posts
			setLinks(allLinks);
		});

		// setLinks([newLink, ...links]);
		setLinkObj({
			title: '',
			subTitle: '',
			url: '',
		});
		// console.log(newLink);
	};

	const updateLink = () => {
		// console.log(editId);

		const editLink = {
			id: editId,
			title: linkObj.title,
			subTitle: linkObj.subTitle,
			url: linkObj.url,
		};

		db.links.update(editId, editLink).then(async (updated) => {
			//retrieve all posts inside the database
			if (updated) {
				let allLinks = await db.links?.reverse().toArray();
				//set the posts
				setLinks(allLinks);
				// console.log(editId + ': got updated');
			}
			// console.log('Nothing was updated');
		});
		// console.log('inside of getpsotinfo');
		setLinkObj({
			title: '',
			subTitle: '',
			url: '',
		});
		setEditState(false);
		// setContent('');
	};

	const onEditLink = (linkItem) => {
		setEditState(true);
		// console.log(linkItem);
		setEditId(linkItem.id);
		setLinkObj({
			title: linkItem.title,
			subTitle: linkItem.subTitle,
			url: linkItem.url,
		});
	};

	const onEditRemove = () => {
		setEditState(false);

		setLinkObj({
			title: '',
			subTitle: '',
			url: '',
		});
	};

	const removeLink = async (id) => {
		// console.log(id);
		// console.log(id);
		db.links.delete(id);
		let allLinks = await db.links.reverse().toArray();
		//set the posts
		setLinks(allLinks);
	};

	return (
		<div className='App'>
			<Layout>
				<div className={classes.root}>
					<List className={classes.listStyle}>
						<ListItem>
							<TextField
								placeholder='Title'
								autoComplete='off'
								type='text'
								name='title'
								value={linkObj.title}
								onChange={handleChangeInput}
								variant='outlined'
								fullWidth={true}
								inputProps={{ maxLength: 10 }}
								className={classes.textFieldStyle}
							/>
						</ListItem>
						<ListItem>
							<TextField
								placeholder='SubTitle'
								autoComplete='off'
								type='text'
								name='subTitle'
								value={linkObj.subTitle}
								onChange={handleChangeInput}
								variant='outlined'
								fullWidth={true}
								inputProps={{ maxLength: 10 }}
								className={classes.textFieldStyle}
							/>
						</ListItem>
						<ListItem>
							<TextField
								placeholder='Link - have to start with http or https'
								autoComplete='off'
								type='text'
								name='url'
								value={linkObj.url}
								onChange={handleChangeInput}
								variant='outlined'
								fullWidth={true}
								className={classes.textFieldStyle}
							/>
						</ListItem>
					</List>
				</div>
				<div className={classes.btnWrapperWraper}>
					<div className={classes.btnWrapper}>
						{editState === false ? (
							<Button
								variant='contained'
								color='primary'
								onClick={() => saveLink()}
								disabled={
									(linkObj.title !== '' &&
										linkObj.url?.includes('http://') === true) ||
									linkObj.url?.includes('https://') === true
										? false
										: true
								}
								fullWidth={true}
							>
								Save Link
							</Button>
						) : (
							<div>
								<Button
									variant='contained'
									color='primary'
									onClick={() => updateLink()}
									disabled={
										(linkObj.title !== '' &&
											linkObj.url?.includes('http://') === true) ||
										linkObj.url?.includes('https://') === true
											? false
											: true
									}
									fullWidth={true}
									className={classes.btnStyle}
								>
									Edit Link
								</Button>
								<Button
									onClick={() => onEditRemove()}
									fullWidth={true}
									variant='contained'
									color='secondary'
								>
									Cancel
								</Button>
							</div>
						)}
					</div>
				</div>

				<LinkList
					links={links}
					onEditLink={onEditLink}
					removeLink={removeLink}
					editState={editState}
				/>
			</Layout>
		</div>
	);
}

export default App;
